'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _DefaultDivider = require('./components/DefaultDivider');

var _DefaultDivider2 = _interopRequireDefault(_DefaultDivider);

var _DividerButton2 = require('./components/DividerButton');

var _DividerButton3 = _interopRequireDefault(_DividerButton2);

var _addDivider = require('./modifiers/addDivider');

var _addDivider2 = _interopRequireDefault(_addDivider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createDividerPlugin = function createDividerPlugin() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$blockType = _ref.blockType,
      blockType = _ref$blockType === undefined ? 'divider' : _ref$blockType,
      _ref$component = _ref.component,
      component = _ref$component === undefined ? _DefaultDivider2.default : _ref$component;

  return {
    blockRendererFn: function blockRendererFn(block) {
      if (block.getType() === blockType) {
        return {
          component: component,
          editable: false
        };
      }
    },
    DividerButton: function DividerButton(props) {
      return _react2.default.createElement(_DividerButton3.default, _extends({}, props, {
        blockType: blockType,
        addDivider: (0, _addDivider2.default)(blockType)
      }));
    },
    addDivider: (0, _addDivider2.default)(blockType)
  };
};

exports.default = createDividerPlugin;